/**
 * authCodes.ts
 * Mirror of legales-api/app/constants/authCodes.js — keep in sync manually.
 * Typed auth code constants for the FE auth state machine.
 *
 * FE-only extended codes (ACCOUNT_LOCKED_PERMANENT, VALIDATION_ERROR) are added
 * below the API mirror for internal FE use.
 */

// ── Mirror of legales-api/app/constants/authCodes.js ──────────────────────────
export const AUTH_CODES = Object.freeze({
  // ── Success ─────────────────────────────────────────────────────────────────
  LOGIN_OK: 'LOGIN_OK',                         // 200 — credentials valid, tokens issued
  MFA_SETUP: 'MFA_SETUP',                       // 203 — first-time TOTP setup, QR returned
  MFA_CHALLENGE: 'MFA_CHALLENGE',               // 428 — TOTP/backup-code challenge required

  // ── Client errors ───────────────────────────────────────────────────────────
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',   // 401
  UNAUTHORIZED: 'UNAUTHORIZED',                 // 401 — generic unauthorized
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',             // 423 — includes unlockAt timestamp
  PASSWORD_EXPIRED: 'PASSWORD_EXPIRED',         // 403
  MFA_INVALID: 'MFA_INVALID',                   // 401 — wrong OTP / backup code
  FORBIDDEN: 'FORBIDDEN',                       // 403 — role not allowed / account disabled
  CONFLICT: 'CONFLICT',                         // 409 — session conflict
  RATE_LIMITED: 'RATE_LIMITED',                 // 429 — IP rate-limited, retryAfter in payload

  // ── Operational ─────────────────────────────────────────────────────────────
  FORGOT_PASSWORD_SENT: 'FORGOT_PASSWORD_SENT', // 200 — reset e-mail dispatched
  LOGOUT_OK: 'LOGOUT_OK',                       // 200 — session invalidated
  MFA_UNAVAILABLE: 'MFA_UNAVAILABLE',           // 503 — upstream MFA provider unreachable
  GATEWAY_ERROR: 'GATEWAY_ERROR',               // 502 — upstream gateway error

  // ── FE-only extended codes ───────────────────────────────────────────────────
  ACCOUNT_LOCKED_PERMANENT: 'ACCOUNT_LOCKED_PERMANENT', // FE: no unlockAt provided
  VALIDATION_ERROR: 'VALIDATION_ERROR',                  // FE: field validation errors
} as const)

export type AuthCode = typeof AUTH_CODES[keyof typeof AUTH_CODES]
